import { useContext} from 'react';
import SingleCustomerContext from '../../Customer-Context/SingleCustomerContext';
import { MultipleCell } from './MultipleCell';
import { StatusCell } from './StatusCell';

interface StatusCellProps {
  record: any;
  accessor: string;
  statuses: any[]
}

export const SwitchCell = ({ record, accessor, statuses }: StatusCellProps) => {
  const { isSingleSelection } = useContext(SingleCustomerContext);

  const lowerCaseStatuses = statuses?.map((status: any) => status?.toLowerCase());
  const isMatchingStatus = (record?.status && typeof record.status === 'string')
    ? lowerCaseStatuses?.includes(record.status.toLowerCase()) 
    : false;
  
  return (
    <>{
      !isSingleSelection ? (
        <MultipleCell 
          record={record}
          accessor={accessor}
          statuses={statuses}
          isMatchingStatus={isMatchingStatus}
        />
      ) : (
        <StatusCell 
          record={record} 
          accessor={accessor} 
          statuses={statuses}/>
      )
    }
      
    </>
  );
} 